import React from 'react';

import { Box, Button, Spacer, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { rem } from '@helpers';

import { ListTextAnimation } from './block';
import { useIntroWizardHelper } from './introWizard.helper';

export const IntroWizard: React.FC = () => {
	const { resources, onPress } = useIntroWizardHelper();

	return (
		<Box
			styles={{
				flexDirection: 'column',
				height: '100%',
				width: '100%',
				alignContent: 'center',
				alignItems: 'flex-start',
				justifyContent: 'center',
				margin: rem(0, 40, 140),
			}}
		>
			<Typography appearance="headline-200-02">{resources.title}</Typography>
			<Spacer vertical={rem(16)} />
			<Typography appearance="subtitle-100-02">{resources.subtitle}</Typography>
			<Spacer vertical={rem(80)} />
			<Button size={'xLarge'} onPress={onPress}>
				{resources.buttonText}
			</Button>
			<Spacer vertical={rem(16)} />
			<ListTextAnimation />
		</Box>
	);
};
